import {Injectable} from '@angular/core';

@Injectable()
export class GnLoginUser {
  username: string;
  name: string;
  authorities: any[];
  isLogin: boolean;
}
